<template>
  <v-app>

    <div class="header">
      <div class="lang">
        <v-select v-model="$i18n.locale" :items="langs" prepend-inner-icon="mdi-web" solo></v-select>
      </div>
    </div>

    <main class="main">
      <Quiz/>
    </main>

  </v-app>
</template>

<script>
import Quiz from './components/Quiz.vue'

export default {
  name: 'app',
  components: {
    Quiz
  },
  data() {
    return {
      langs: [
        { text: "English", value: "en" },
        { text: "Norsk", value: "no" },
        { text: "Polski", value: "pl" },
        { text: "Русский", value: "ru" },
        { text: "日本語", value: "jpn" },
      ]
    }
  },
}
</script>

<style lang="scss">
* { box-sizing: border-box; }
img { max-width: 100%; }
button, input { border: 0; }

#app {
  color: #546E7A;
  line-height: 1.5;
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #eceff1;
  background-image: url("~@/assets/bg.svg");

  display: flex;
  justify-content: center;
  flex-direction: column;
  min-height: 100vh;
}

.header {
  padding: 1rem;
  display: flex;
  justify-content: flex-end;

  .lang { max-width: 10rem; }
}

.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1 1 100%;
  padding: 1rem;
}
</style>
